<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <div class="index-box">
      <select-model-table
        v-model="options"
        :module-name="moduleName"
        :controller-name="controllerName"
        :label-name="labelName"
        :condition="condition"
        :hidden-fields="hiddenFields"
      />
    </div>
    <div class="form-btn-group">
      <sc-btn :handler="onSubmit" text="确定" type="primary" />
      <sc-btn :handler="onReset" style="margin-left: 10px" text="重置" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';

const props = defineProps<{
  moduleName: string;
  controllerName: string;
  labelName: string;
  hiddenFields?: string[]; // 隐藏字段
  condition?: any;
}>();

const options = ref<any[]>([]);

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  if (windowTool) {
    windowTool.close(options.value);
  }
}

function onReset() {
  options.value = [];
}
</script>

<style lang="scss" scoped>
.index-box {
  flex-grow: 1;
  overflow: auto;
  padding: 20px;
}

.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;

  .select-form {
    margin-bottom: $spacing-medium;

    .select-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: $spacing-medium;

      .select-label {
        margin-right: $spacing-medium;
      }

      .select {
        width: 80%;
      }
    }
  }
}
</style>
